import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/gla_thumb.png"

export function Index() {
  return (
    <Layout
      title="GLA Global Conference Success with Premagic AI Photo Distribution"
      description="GLA Global enhanced international business networking and professional engagement using AI-powered photo distribution at their global conferences."
      metaImage={ThumbnailImage}
      keywords={[
        "GLA Global case study, international business conference, global leadership events, business networking photos, corporate leadership summit, international networking events, business conference technology, global business community, leadership event photos, international corporate events, business summit networking, global business networking, corporate leadership photos, international business solutions, executive networking events",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "GLA Global", url: "/case-study/gla-global/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "GLA Global Conference Success with Premagic AI Photo Distribution",
            "description": "GLA Global enhanced international business networking and professional engagement using AI-powered photo distribution at their global conferences.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.GLA_GLOBAL} />
    </Layout>
  )
}

export default Index
